import PageBackTitle from "../Component/PageBackTitle";
import React, { useState, useEffect, useContext } from "react";
import "./UserForm.css";
import "./EquipmentTypeVariantForm.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import API_URL from "../../src/Config";
import Select, { components } from "react-select";
import { CiCirclePlus } from "react-icons/ci";
import AddDepartmentPopup from "../Popups/AddDepartmentPopup";
import AddEquipmentType from "../Popups/AddEquipmentType";
import AddEquipmentSubType from "../Popups/AddEquipmentSubType";
import AddSubDepartmentPopup from "../Popups/AddSubDepartmentPopup";
import { ThemeContext } from "../../src/ThemeContext";

const { Control, Menu } = components;

function EquipmentTypevariantForm({ isSidebarExpanded }) {
  const navigate = useNavigate();
  const { theme } = useContext(ThemeContext);

  // Options + selections
  const [departments, setDepartments] = useState([]);
  const [subDepartments, setSubDepartments] = useState([]);
  const [equipmentTypes, setEquipmentTypes] = useState([]);
  const [equipmentSubTypes, setEquipmentSubTypes] = useState([]);

  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedSubDepartment, setSelectedSubDepartment] = useState(null);
  const [selectedEquipmentTypes, setSelectEdequipmentType] = useState(null);
  const [selectedEquipmentSubType, setSelectedEquipmentSubType] = useState(null);

  // Popups
  const [showDepartmentPopup, setShowDepartmentPopup] = useState(false);
  const [showSubDepartmentPopup, setShowSubDepartmentPopup] = useState(false);
  const [showequipmentTypePopup, setShowequipmentTypePopup] = useState(false);
  const [showSubTypePopup, setShowSubTypePopup] = useState(false);

  // Menus open/close
  const [departmentMenuIsOpen, setDepartmentMenuIsOpen] = useState(false);
  const [subDepartmentMenuIsOpen, setSubDepartmentMenuIsOpen] = useState(false);
  const [EquipmentTypeMenuIsOpen, setEquipmentTypeMenuIsOpen] = useState(false);
  const [EquipmentSubTypeMenuIsOpen, setEquipmentSubTypeMenuIsOpen] = useState(false);

  // Form data (keys aligned to backend)
  const [equipmentSubTypeVariantData, setEquipmentSubTypeVariantData] = useState({
    EquipmentSubType: "",
    EquipmentSubTypeId: null,
    VariantName: "", // <-- consistent key
    Frequencies: [{ OISDPoint: "", Frequency: "" }],
    DepartmentId: "",
    DepartmentName: "",
    EquipmentType: "",
    EquipmentTypeId: "",
    SubDepartmentId: "",
    SubDepartmentName: "",
  });

  // Errors
  const [errors, setErrors] = useState({
    DepartmentName: "",
    SubDepartmentName: "",
    EquipmentType: "",
    EquipmentSubType: "",
    variantName: "", // message holder for VariantName
  });

  // UI State
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("success");

  // ---------------- Helpers ----------------
  const showSnackbar = (message, sev = "success") => {
    setSnackbarMessage(message);
    setSeverity(sev);
    setSnackbarOpen(true);
  };
  const handleSnackbarClose = (e, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };
  const closeAllPopups = () => {
    setDepartmentMenuIsOpen(false);
    setSubDepartmentMenuIsOpen(false);
    setEquipmentTypeMenuIsOpen(false);
    setEquipmentSubTypeMenuIsOpen(false);
  };

  // ---------------- Field Changes ----------------
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setEquipmentSubTypeVariantData((prev) => ({ ...prev, [name]: value }));
    if (name === "VariantName") {
      setErrors((prev) => ({ ...prev, variantName: "" }));
    }
  };

  const handleFrequencyChange = (index, event) => {
    const { name, value } = event.target;
    const updated = [...equipmentSubTypeVariantData.Frequencies];
    updated[index][name] = value;
    setEquipmentSubTypeVariantData((prev) => ({ ...prev, Frequencies: updated }));
  };

  const handleAddFrequencyRow = () => {
    setEquipmentSubTypeVariantData((prev) => ({
      ...prev,
      Frequencies: [...prev.Frequencies, { OISDPoint: "", Frequency: "" }],
    }));
  };

  const handleCloseFrequencyRow = (index) => {
    setEquipmentSubTypeVariantData((prev) => {
      const updated = prev.Frequencies.filter((_, i) => i !== index);
      return { ...prev, Frequencies: updated.length ? updated : [{ OISDPoint: "", Frequency: "" }] };
    });
  };

  // ---------------- Custom Select components ----------------
  const CustomControl = ({ children, ...props }) => <Control {...props}>{children}</Control>;
  const CustomMenu = ({ children, ...props }) => (
    <Menu {...props}>
      {children}
      <button
        type="button"
        className="add-company-button"
        onClick={() => {
          setShowDepartmentPopup(true);
          setDepartmentMenuIsOpen(false);
        }}
      >
        <CiCirclePlus className="new-plus-circle" />
        Add New Department
      </button>
    </Menu>
  );

  const CustomSubDepartmentControl = ({ children, ...props }) => <Control {...props}>{children}</Control>;
  const CustomSubDepartmentMenu = ({ children, ...props }) => (
    <Menu {...props}>
      {children}
      <button
        type="button"
        className="add-company-button"
        onClick={() => {
          setShowSubDepartmentPopup(true);
          setSubDepartmentMenuIsOpen(false);
        }}
      >
        <CiCirclePlus className="new-plus-circle" />
        Add New Sub Department
      </button>
    </Menu>
  );

  const CustomTypeControl = ({ children, ...props }) => <Control {...props}>{children}</Control>;
  const CustomTypeMenu = ({ children, ...props }) => (
    <Menu {...props}>
      {children}
      <button
        type="button"
        className="add-company-button"
        onClick={() => {
          setShowequipmentTypePopup(true);
          setEquipmentTypeMenuIsOpen(false);
        }}
      >
        <CiCirclePlus className="new-plus-circle" />
        Add Equipment Type
      </button>
    </Menu>
  );

  const CustomSubControl = ({ children, ...props }) => <Control {...props}>{children}</Control>;
  const CustomSubMenu = ({ children, ...props }) => (
    <Menu {...props}>
      {children}
      <button
        type="button"
        className="add-company-button"
        onClick={() => {
          setShowSubTypePopup(true);
          setEquipmentSubTypeMenuIsOpen(false);
        }}
      >
        <CiCirclePlus className="new-plus-circle" />
        Add Equipment Sub Type
      </button>
    </Menu>
  );

  // ---------------- Select styles ----------------
  const selectStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: theme === "dark" ? "black" : "white",
      color: theme === "dark" ? "#fff" : "#333",
      borderColor: theme === "dark" ? "#444" : "#ccc",
      cursor: "pointer",
      boxShadow: "none",
      "&:hover": { borderColor: theme === "dark" ? "#666" : "#888" },
    }),
    menu: (provided) => ({ ...provided, backgroundColor: theme === "dark" ? "#000" : "#fff" }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? theme === "dark"
          ? "#666"
          : "lightblue"
        : theme === "dark"
        ? "#000"
        : "#fff",
      color: state.isFocused ? "#fff" : theme === "dark" ? "#fff" : "#333",
      cursor: "pointer",
    }),
    singleValue: (provided) => ({ ...provided, color: theme === "dark" ? "#fff" : "#333" }),
  };

  // ---------------- Data fetch ----------------
  const fetchDepartment = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const apiUrl = `${API_URL}/api/get_departments`;
      const res = await fetch(apiUrl, {
        headers: { "Content-Type": "application/json", Authorization: authKey },
      });
      if (!res.ok) throw new Error("Failed to fetch departments");
      const data = await res.json();
      setDepartments(data.map((d) => ({ label: d.DepartmentName, value: d.ID })));
    } catch (e) {
      console.error(e);
    }
  };

  const fetchSubDepartments = async () => {
    try {
      if (!selectedDepartment) {
        setSubDepartments([]);
        return;
      }
      const authKey = localStorage.getItem("authKey");
      const apiUrl = `${API_URL}/api/get_sub_department/${selectedDepartment.value}`;
      const res = await fetch(apiUrl, {
        headers: { "Content-Type": "application/json", Authorization: authKey },
      });
      if (!res.ok) throw new Error("Failed to fetch sub-departments");
      const data = await res.json();
      setSubDepartments(data.map((s) => ({ label: s.Name, value: s.id })));
    } catch (e) {
      console.error(e);
    }
  };

  const fetchEquipmentTypes = async (subDepartmentId) => {
    try {
      const authKey = localStorage.getItem("authKey");
      const apiUrl = `${API_URL}/api/get_equipment_types_by_sub_department/${subDepartmentId}`;
      const res = await fetch(apiUrl, {
        headers: { "Content-Type": "application/json", Authorization: authKey },
      });
      if (!res.ok) throw new Error("Failed to fetch equipment types");
      const data = await res.json();
      setEquipmentTypes(data.map((t) => ({ label: t.EquipmentType, value: t.id })));
    } catch (e) {
      console.error(e);
    }
  };

  const fetchEquipmentSubType = async (equipmentTypeId) => {
    try {
      const authKey = localStorage.getItem("authKey");
      const apiUrl = `${API_URL}/api/get_equipment_sub_types_by_type/${equipmentTypeId}`;
      const res = await fetch(apiUrl, {
        headers: { "Content-Type": "application/json", Authorization: authKey },
      });
      if (!res.ok) throw new Error("Failed to fetch equipment sub types");
      const data = await res.json();
      setEquipmentSubTypes(data.map((s) => ({ label: s.EquipmentSubType, value: s.id })));
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchDepartment();
  }, []);

  useEffect(() => {
    // when department changes
    setSelectedSubDepartment(null);
    setSubDepartments([]);
    setSelectEdequipmentType(null);
    setSelectedEquipmentSubType(null);
    if (selectedDepartment) fetchSubDepartments();
  }, [selectedDepartment]);

  // ---------------- Select handlers ----------------
  const handleDepartmentChange = (opt) => {
    setSelectedDepartment(opt);
    setEquipmentSubTypeVariantData((prev) => ({
      ...prev,
      DepartmentName: opt?.label || "",
      DepartmentId: opt?.value || "",
      // reset downstream
      SubDepartmentId: "",
      SubDepartmentName: "",
      EquipmentType: "",
      EquipmentTypeId: "",
      EquipmentSubType: "",
      EquipmentSubTypeId: "",
    }));
    setErrors((prev) => ({ ...prev, DepartmentName: "" }));
  };

  const handleSubDepartmentChange = (opt) => {
    setSelectedSubDepartment(opt);
    setEquipmentSubTypeVariantData((prev) => ({
      ...prev,
      SubDepartmentName: opt?.label || "",
      SubDepartmentId: opt?.value || "",
      // reset downstream
      EquipmentType: "",
      EquipmentTypeId: "",
      EquipmentSubType: "",
      EquipmentSubTypeId: "",
    }));
    if (opt?.value) fetchEquipmentTypes(opt.value);
    setSelectEdequipmentType(null);
    setSelectedEquipmentSubType(null);
    setErrors((prev) => ({ ...prev, SubDepartmentName: "" }));
  };

  const handleEquipmentTypeChange = (opt) => {
    setSelectEdequipmentType(opt);
    setEquipmentSubTypeVariantData((prev) => ({
      ...prev,
      EquipmentType: opt?.label || "",
      EquipmentTypeId: opt?.value || "",
      // reset downstream
      EquipmentSubType: "",
      EquipmentSubTypeId: "",
    }));
    if (opt?.value) fetchEquipmentSubType(opt.value);
    setSelectedEquipmentSubType(null);
    setErrors((prev) => ({ ...prev, EquipmentType: "" }));
  };

  const handleTypeSubTypeChange = (opt) => {
    setSelectedEquipmentSubType(opt);
    setEquipmentSubTypeVariantData((prev) => ({
      ...prev,
      EquipmentSubType: opt?.label || "",
      EquipmentSubTypeId: opt?.value || "",
    }));
    setErrors((prev) => ({ ...prev, EquipmentSubType: "" }));
  };

  // ---------------- Save ----------------
  const handleSaveClick = async () => {
    const updatedErrors = { ...errors };
    let hasError = false;

    if (!selectedDepartment) {
      updatedErrors.DepartmentName = "Department is required.";
      hasError = true;
    } else updatedErrors.DepartmentName = "";

    if (!selectedSubDepartment) {
      updatedErrors.SubDepartmentName = "Sub Department is required.";
      hasError = true;
    } else updatedErrors.SubDepartmentName = "";

    if (!selectedEquipmentTypes) {
      updatedErrors.EquipmentType = "Equipment Type is required.";
      hasError = true;
    } else updatedErrors.EquipmentType = "";

    if (!selectedEquipmentSubType) {
      updatedErrors.EquipmentSubType = "Equipment Sub Type is required.";
      hasError = true;
    } else updatedErrors.EquipmentSubType = "";

    if (!equipmentSubTypeVariantData.VariantName || !equipmentSubTypeVariantData.VariantName.trim()) {
      updatedErrors.variantName = "Equipment Sub Type Variant is required.";
      hasError = true;
    } else updatedErrors.variantName = "";

    setErrors(updatedErrors);
    if (hasError) return;

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");
      const payload = { ...equipmentSubTypeVariantData };
      const res = await axios.post(`${API_URL}/api/add_sub_type_variant`, payload, {
        headers: { Authorization: authKey },
      });
      if (res.status === 200) {
        showSnackbar("Sub type variant added successfully", "success");
        setTimeout(() => navigate("/equipment-sub-type-variant"), 1000);
      } else {
        showSnackbar("Failed to add sub type variant", "error");
      }
    } catch (err) {
      console.error("Error saving:", err?.message || err);
      showSnackbar("Error saving sub type variant", "error");
    } finally {
      setIsLoading(false);
    }
  };

  // ---------------- Keyboard + navigation ----------------
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSaveClick();
    }
  };
  const handleCancelClick = () => navigate("/equipment-sub-type-variant");

  // ---------------- Menu open handlers ----------------
  const handleDepartmentMenuOpen = () => {
    closeAllPopups();
    setDepartmentMenuIsOpen(true);
  };
  const handleSubDepartmentMenuOpen = () => {
    closeAllPopups();
    setSubDepartmentMenuIsOpen(true);
  };
  const handleEquipmentTypeMenuOpen = () => {
    closeAllPopups();
    setEquipmentTypeMenuIsOpen(true);
  };
  const handleEquipmentSubTypeMenuOpen = () => {
    closeAllPopups();
    setEquipmentSubTypeMenuIsOpen(true);
  };

  // ---------------- Popup close/add handlers ----------------
  const closeDepartmentPopup = () => setShowDepartmentPopup(false);

  const handleNewDepartment = (newDepartment) => {
    if (!newDepartment) return;
    setDepartments((prev) => [...prev, newDepartment]);
    setSelectedDepartment(newDepartment);
    setEquipmentSubTypeVariantData((prev) => ({
      ...prev,
      DepartmentName: newDepartment.label,
      DepartmentId: newDepartment.value,
    }));
    showSnackbar("Department added successfully");
  };

  const handleNewSubDepartment = (newSubDepartment) => {
    setSubDepartments((prev) => [...prev, newSubDepartment]);
    setSelectedSubDepartment(newSubDepartment);
    setEquipmentSubTypeVariantData((prev) => ({
      ...prev,
      SubDepartmentName: newSubDepartment.label,
      SubDepartmentId: newSubDepartment.value,
    }));
    showSnackbar("Sub Department added successfully");
  };

  const closeSubDepartmentPopup = (newSubDepartment) => {
    setShowSubDepartmentPopup(false);
    fetchSubDepartments();
    if (newSubDepartment) {
      const opt = { label: newSubDepartment.SubDepartment, value: newSubDepartment.id };
      setSelectedSubDepartment(opt);
      setEquipmentSubTypeVariantData((prev) => ({
        ...prev,
        SubDepartmentName: opt.label,
        SubDepartmentId: opt.value,
      }));
      showSnackbar("Sub Department added successfully");
    }
  };

  const closeEquipmentTypePopup = () => setShowequipmentTypePopup(false);
  const handleNewEquipmentType = (newEquipment) => {
    setEquipmentTypes((prev) => [...prev, newEquipment]);
    setSelectEdequipmentType(newEquipment);
    setEquipmentSubTypeVariantData((prev) => ({
      ...prev,
      EquipmentType: newEquipment.label,
      EquipmentTypeId: newEquipment.value,
    }));
    showSnackbar("Equipment type added successfully");
  };

  const closeSubTypePopup = (newSubType) => {
    setShowSubTypePopup(false);
    if (newSubType) {
      setEquipmentSubTypes((prev) => [...prev, newSubType]);
      setSelectedEquipmentSubType(newSubType);
      setEquipmentSubTypeVariantData((prev) => ({
        ...prev,
        EquipmentSubType: newSubType.label,
        EquipmentSubTypeId: newSubType.value,
      }));
    }
  };

  const handleNewEquipmentSubType = (newSubEquipment) => {
    setEquipmentSubTypes((prev) => [...prev, newSubEquipment]);
    setSelectedEquipmentSubType({ label: newSubEquipment.label, value: newSubEquipment.value });
    showSnackbar("Equipment sub type added successfully");
  };

  // ---------------- Render ----------------
  return (
    <>
      <div className={`data-form-content-container page-content ${isSidebarExpanded ? "expanded" : "collapsed"}`}>
        <div className="data-form-content">
          <div className="data-form-header">
            <div className="data-form-header-content">
              <PageBackTitle className="data-form-heading-content-left-side">New Equipment Sub Type Variant</PageBackTitle>
              <div className="data-form-heading-content-right-side"></div>
            </div>
          </div>
          <div className="header-separator"></div>

          <div className="data-form-body">
            <form className="form-detail" onKeyDown={handleKeyDown}>
              <div className="new-data-form">
                {/* Department */}
                <div className="form-group-select">
                  <label htmlFor="department">
                    Department<span className="text-danger">*</span>
                  </label>
                  <Select
                    id="department"
                    options={departments}
                    value={selectedDepartment}
                    onChange={handleDepartmentChange}
                    components={{ Control: CustomControl, Menu: CustomMenu }}
                    placeholder="Select Department"
                    isSearchable
                    menuIsOpen={departmentMenuIsOpen}
                    onMenuOpen={handleDepartmentMenuOpen}
                    onMenuClose={() => setDepartmentMenuIsOpen(false)}
                    styles={selectStyles}
                  />
                  {errors.DepartmentName && <div className="error-message">{errors.DepartmentName}</div>}
                </div>

                {/* Sub Department */}
                <div className="form-group-select">
                  <label htmlFor="subDepartment">
                    Sub Department<span className="text-danger">*</span>
                  </label>
                  <Select
                    id="subDepartment"
                    options={subDepartments}
                    value={selectedSubDepartment}
                    onChange={handleSubDepartmentChange}
                    components={{ Control: CustomSubDepartmentControl, Menu: CustomSubDepartmentMenu }}
                    placeholder="Select Sub Department"
                    isSearchable
                    menuIsOpen={subDepartmentMenuIsOpen}
                    onMenuOpen={handleSubDepartmentMenuOpen}
                    onMenuClose={() => setSubDepartmentMenuIsOpen(false)}
                    styles={selectStyles}
                  />
                  {errors.SubDepartmentName && <div className="error-message">{errors.SubDepartmentName}</div>}
                </div>

                {/* Equipment Type */}
                <div className="form-group-select">
                  <label htmlFor="EquipmentType">
                    Equipment Type<span className="text-danger">*</span>
                  </label>
                  <Select
                    id="EquipmentType"
                    options={equipmentTypes}
                    value={selectedEquipmentTypes}
                    onChange={handleEquipmentTypeChange}
                    components={{ Control: CustomTypeControl, Menu: CustomTypeMenu }}
                    placeholder="Select Equipment Type"
                    isSearchable
                    menuIsOpen={EquipmentTypeMenuIsOpen}
                    onMenuOpen={handleEquipmentTypeMenuOpen}
                    onMenuClose={() => setEquipmentTypeMenuIsOpen(false)}
                    styles={selectStyles}
                  />
                  {errors.EquipmentType && <div className="error-message">{errors.EquipmentType}</div>}
                </div>

                {/* Equipment Sub Type */}
                <div className="form-group-select">
                  <label htmlFor="EquipmentSubType">
                    Sub Type<span className="text-danger">*</span>
                  </label>
                  <Select
                    id="EquipmentSubType"
                    options={equipmentSubTypes}
                    value={selectedEquipmentSubType}
                    onChange={handleTypeSubTypeChange}
                    components={{ Control: CustomSubControl, Menu: CustomSubMenu }}
                    placeholder="Select Sub Type"
                    isSearchable
                    menuIsOpen={EquipmentSubTypeMenuIsOpen}
                    onMenuOpen={handleEquipmentSubTypeMenuOpen}
                    onMenuClose={() => setEquipmentSubTypeMenuIsOpen(false)}
                    styles={selectStyles}
                  />
                  {errors.EquipmentSubType && <div className="error-message">{errors.EquipmentSubType}</div>}
                </div>

                {/* Variant Name */}
                <div className="form-group">
                  <label htmlFor="VariantName">
                    Equipment Sub Type Variant <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      id="VariantName"
                      name="VariantName"
                      value={equipmentSubTypeVariantData.VariantName || ""}
                      onChange={handleInputChange}
                      placeholder="Enter Sub Type Variant"
                    />
                  </div>
                  {errors.variantName && <div className="error-message">{errors.variantName}</div>}
                </div>

                {/* Frequencies (optional UI)
                {equipmentSubTypeVariantData.Frequencies.map((row, idx) => (
                  <div key={idx} className="form-row frequency-row">
                    <input
                      type="text"
                      name="OISDPoint"
                      placeholder="OISD Point"
                      value={row.OISDPoint || ""}
                      onChange={(e) => handleFrequencyChange(idx, e)}
                    />
                    <input
                      type="text"
                      name="Frequency"
                      placeholder="Frequency"
                      value={row.Frequency || ""}
                      onChange={(e) => handleFrequencyChange(idx, e)}
                    />
                    <button type="button" onClick={() => handleCloseFrequencyRow(idx)}>Remove</button>
                  </div>
                ))}
                <button type="button" onClick={handleAddFrequencyRow}>Add Frequency</button>
                */}
              </div>
            </form>

            {/* Popups */}
            {showDepartmentPopup && (
              <div className="inquiry-customerperson-popup">
                <AddDepartmentPopup
                  closePopup={closeDepartmentPopup}
                  setSelectedDepartment={setSelectedDepartment}
                  handleNewDepartment={handleNewDepartment}
                />
              </div>
            )}

            {showSubDepartmentPopup && (
              <div className="inquiry-customerperson-popup">
                <AddSubDepartmentPopup
                  closePopup={closeSubDepartmentPopup}
                  selectedDepartment={selectedDepartment}
                  parentSelectedDepartment={selectedDepartment}
                  handleNewSubDepartment={handleNewSubDepartment}
                />
              </div>
            )}

            {showequipmentTypePopup && (
              <div className="inquiry-customerperson-popup">
                <AddEquipmentType
                  closePopup={closeEquipmentTypePopup}
                  setSelectEdequipmentType={setSelectEdequipmentType}
                  handleNewEquipmentType={handleNewEquipmentType}
                  parentSelectedDepartment={selectedDepartment}
                  parentSelectedSubDepartment={selectedSubDepartment}
                />
              </div>
            )}

            {showSubTypePopup && (
              <div className="inquiry-customerperson-popup">
                <AddEquipmentSubType
                  closePopup={closeSubTypePopup}
                  setSelectedEquipmentSubType={setSelectedEquipmentSubType}
                  parentSelectedEquipmentType={selectedEquipmentTypes}
                  handleNewEquipmentSubType={handleNewEquipmentSubType}
                />
              </div>
            )}
          </div>

          <div className="footer">
            <div className="button-group">
              <button className="data-form-save-button" type="button" onClick={handleSaveClick} disabled={isLoading}>
                {isLoading ? "Saving..." : "Save"}
              </button>
              <button className="data-form-cancel-button" type="button" onClick={handleCancelClick}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ transform: "translateY(40px)", marginLeft: "15px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default EquipmentTypevariantForm;
